<template>
    <div class="vx-row" v-if="account.id">
            
        <div class="vx-col w-full mb-base">
            <vx-card :title="`Load Credits for ${account.name}`">
               <vs-tabs>
                    <vs-tab label="Credit Card">
                        
                        <div class="vx-row mb-6 mt-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Credit Card Number</span>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input class="w-full" icon-pack="feather" icon="icon-credit-card" icon-no-border v-model="credit.num" />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Cardholder Name</span>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input type="email" class="w-full" icon-pack="feather" icon="icon-user" icon-no-border v-model="credit.name" />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>Expiry Date</span>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input class="w-full" icon-pack="feather" icon="icon-credit-card" icon-no-border v-model="credit.expiry" />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/3 w-full">
                                <span>CVV</span>
                            </div>
                            <div class="vx-col sm:w-2/3 w-full">
                                <vs-input type="password" class="w-full" icon-pack="feather" icon="icon-credit-card" icon-no-border v-model="credit.cvv" />
                            </div>
                        </div>
                      
                        <div class="vx-row">
                            <div class="vx-col sm:w-2/3 w-full ml-auto">
                                <vs-button class="mr-3 mb-2">Submit</vs-button>
                                <vs-button color="warning" type="border" class="mb-2" @click="input5 = input6 = input7 = input8 = ''; check2 = false;">Reset</vs-button>
                            </div>
                        </div>

                    </vs-tab>
                    <vs-tab label="Cheque">
                        <div></div>
                    </vs-tab>
                    <vs-tab label="Manual">
                        <div></div>
                    </vs-tab>
                   
                </vs-tabs>
            </vx-card>
        </div>

    </div>
</template>

<script>
export default {
    data(){
        return {
            credit:{
                ccNum:'',
                expiry:'',
                name:'',
                cvv:''
                
            }
        }
    },
    computed:{
        account(){
            return this.$store.state.viewDetail
        }
    },
    created(){
        console.log('CREDIT LOAIND', this.$route.params.id)
    }
}
</script>

<style>

</style>